<template>
  <v-container fluid class="py-2">
    <v-row>
      <v-col cols="12">
        <company-table></company-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import CompanyTable from "./Widgets/CompanyTable.vue";

export default {
  name: "CompanyList",
  components: {
    CompanyTable,
  },
};
</script>
